import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';

type MutationFnType = typeof mutationFn;

interface DTO {
    keyId: string;
    parkingId: string;
}
const mutationFn = ({ keyId, parkingId }: DTO): Promise<void> => {
    return axios.delete(`sp-core/${parkingId}/system/api-key/${keyId}/`);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteApiKey };
